import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'

export const usePreloaderModel = defineStore('preloader', () => {
  const status = ref<boolean>(false)

  return {
    status
  }
})
